export default __webpack_public_path__ + "static/media/visa.a174c95e.svg";